import { apiClient } from '@borradh-workspace/api-client';
import {
  type ClaireBlockedCampaignsResponseContract,
  claireBlockedCampaignsResponseSchema,
} from '@borradh-workspace/contracts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { claireBlockedCampaignsQueryKey } from '../get-claire-blocked-campaigns';

export const useUpdateClaireBlockedCampaigns = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({
      organizationId,
      campaignIds,
    }: {
      organizationId: string;
      campaignIds: string[];
    }) =>
      apiClient.put<ClaireBlockedCampaignsResponseContract>(
        `organizations/${organizationId}/claire-blocked-campaigns`,
        { campaignIds },
        { schema: claireBlockedCampaignsResponseSchema }
      ),
    onSuccess: (data, { organizationId }) => {
      queryClient.setQueryData(
        claireBlockedCampaignsQueryKey(organizationId),
        data
      );
      toast.success('Blocked campaigns saved');
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to save blocked campaigns');
    },
  });

  return {
    updateBlockedCampaigns: mutation.mutate,
    isUpdating: mutation.isPending,
  };
};
